import { INFO_NOT_AVAILABLE_NA } from '@backoffice-frontend/common'
import { FccWaypointHubReturnReason } from '@backoffice-frontend/graphql'
import { CoffeeIcon, HomeEnterIcon } from '@moia-dev/pace-icons'
import { Icon, Text } from '@moia-dev/pace-web'
import { format } from 'date-fns'
import startCase from 'lodash/startCase'
import { useTranslation } from 'react-i18next'
import type { VehicleMissionFccUpcomingWaypoint } from '../parseVehicle'

export const VEHICLE_MISSION_CARD_FOOTER_HEIGHT = 41

type VehicleMissionCardFooterProps = {
  waypoint?: VehicleMissionFccUpcomingWaypoint
  cardHasListOfMultipleWaypoints: boolean
}

export const VehicleMissionCardFooter = ({
  waypoint,
  cardHasListOfMultipleWaypoints,
}: VehicleMissionCardFooterProps) => {
  const { t, i18n } = useTranslation()

  const firstWaypointAction = waypoint?.actions.at(0)
  const hubReturnReason =
    firstWaypointAction?.__typename === 'FccWaypointHubReturnAction'
      ? firstWaypointAction.reason
      : null

  const waypointStopName = waypoint?.stop?.names[i18n.language]

  const hubReturn = waypoint?.actions.find(
    wp => wp.__typename === 'FccWaypointHubReturnAction',
  )
  const hubName =
    firstWaypointAction?.__typename === 'FccWaypointHubReturnAction'
      ? firstWaypointAction.area?.details?.__typename === 'HubDetails'
        ? firstWaypointAction.area.details.displayName
        : firstWaypointAction.area?.name
      : null
  const hubReturnDate = hubReturn?.estimatedAt
    ? new Date(hubReturn.estimatedAt)
    : null
  const hubReturnTime = hubReturnDate ? format(hubReturnDate, 'HH:mm') : null

  return (
    <div
      css={theme => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'absolute',
        bottom: 0,
        padding: `${theme.space.Space2} ${theme.space.Space4}`,
        height: VEHICLE_MISSION_CARD_FOOTER_HEIGHT,
        width: '100%',
        borderTop: cardHasListOfMultipleWaypoints
          ? `1px solid ${theme.semantic.ColorAccessoryReduced}`
          : 0,
        background: theme.semantic.ColorSurfaceReducedAlternative,
        color: theme.semantic.ColorContentReduced,
        zIndex: 100,
      })}
    >
      <div css={{ display: 'flex', alignItems: 'center' }}>
        {hubReturnReason === FccWaypointHubReturnReason.ShortBreak ||
        hubReturnReason === FccWaypointHubReturnReason.DriverBreak ? (
          <Icon
            size={20}
            css={theme => ({
              color: theme.semantic.ColorContentReduced,
            })}
          >
            <CoffeeIcon />
          </Icon>
        ) : (
          <Icon
            size={20}
            css={theme => ({
              color: theme.semantic.ColorContentReduced,
            })}
          >
            <HomeEnterIcon />
          </Icon>
        )}
        <Text
          color="reduced"
          css={theme => ({ paddingLeft: theme.space.Space1 })}
        >
          {hubName || waypointStopName
            ? startCase(
                hubName?.toLowerCase() ?? waypointStopName?.toLowerCase(),
              )
            : INFO_NOT_AVAILABLE_NA}
        </Text>
      </div>
      <div css={{ display: 'flex', alignItems: 'center' }}>
        <Text color="reduced">{`${t('adFleetMap_missionCard_hubReturnPlannedFor_label')} ${hubReturnTime ?? INFO_NOT_AVAILABLE_NA}`}</Text>
      </div>
    </div>
  )
}
